export default __webpack_public_path__ + "static/media/pic4.b761a4d0.jpg";